import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import SignaturePad from "react-signature-canvas";
import { connect } from "react-redux";
// import { getTransactionDataAction } from "../../actions/TransactionActions";
import { getPublicFormTransactionDataAction } from "../../actions/TransactionActions";
// import { addDocAction, uploadDocumentAction } from "./../../actions/DocActions";
import { publicAddDocAction, publicUploadDocumentAction } from "./../../actions/DocActions";
import {
  logout,
  loginUserAction,
  loginUserPublicFormsAction,
  addContactByPublicFormAction,
} from "../../actions/UserActions";
import { formatPhoneNumber, toastMessage } from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import * as code from "./../../config/Constants";
import StickyHeaderPublic from "./StickyHeaderPublic";
import InputMask from "react-input-mask";
import FooterPublic from "./FooterPublic";
var _ = require("lodash");

// var systemLoginValues = {
//   email: process.env.REACT_APP_SYSTEMLOGINVALUES_EMAIL,
//   password: process.env.REACT_APP_SYSTEMLOGINVALUES_PASSWARD,
// };

class ConsentPublic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionId: this.props.formData && this.props.formData.transactionId,
      studioName: "",
      clientFirstName: "",
      clientLastName: "",
      clientEmail: "",
      clientPhone: "",
      guardianName: "",
      guardianEmail: "",
      guardianPhone: "",
      hasGuardian: false,
      errors: {},
    };

    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  loginForPublicForm() {
    let data = { WEbEOpurMgk: "5GfFObGWzC5PNVTVbMA" };
    return this.props.loginUserPublicFormsAction(data).then((loginRes) => {});
  }

  async getTransactionData() {
    //await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let transId = this.state.transactionId;
    let transaction = [];
    if (!(this.props.formData && this.props.formData.isBlankForm)) {
      await this.props
        .getPublicFormTransactionDataAction(transId)
        .then((transDataRes) => {
          transaction.push(this.props.transactionData);

          for (let i = 0; i < transaction.length; i++) {
            this.setState({
              studioName: transaction[i].dsd.property.name,
              clientFirstName: transaction[i].dsd.buyer[0].firstname,
              clientLastName: transaction[i].dsd.buyer[0].lastname
                ? transaction[i].dsd.buyer[0].lastname
                : "",
              clientEmail: transaction[i].dsd.buyer[0].email,
              clientPhone: transaction[i].dsd.buyer[0].mobileNumber,
              guardianName:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].firstname +
                    " " +
                    transaction[i].dsd.closingAgents[0].lastname
                  : "",
              guardianEmail:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].email
                  : "",
              guardianPhone:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].mobileNumber
                  : "",
              hasGuardian:
                transaction[i].dsd.closingAgents.length !== 0 ? true : false,
            });
          }
        });
    }

    this.props.logout();
  }

  componentDidMount() {
    this.getTransactionData();
  }

  async exportFormToPDF() {
    //await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();
    let clientFullName =
      this.state.clientFirstName.trim() +
      (this.state.clientLastName ? " " + this.state.clientLastName.trim() : "");
    let fileName =
      "consent" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1200 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    //add client only for QR code scan link
    if (
      this.props.formData &&
      this.props.formData.isBlankForm &&
      (this.state.clientEmail || this.state.clientPhone)
    ) {
      let data = {
        firstname: this.state.clientFirstName,
        lastname: this.state.clientLastName,
        email: this.state.clientEmail,
        mobileNumber: this.state.clientPhone.replace(/-/g, ""),
        usertype: "Client",
        transactionId: transId,
        knowAboutUs: this.props.formData && this.props.formData.knowAboutUs,
      };
      this.props.addContactByPublicFormAction(data).then((res) => {});
    }

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.publicAddDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .publicUploadDocumentAction(
              formData,
              transId,
              undefined,
              fileUploadName
            )
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf()
                .set(opt)
                .from(form)
                .save();
              this.props.logout();
              this.props.history.push("/formreceived");
            });
        });
      } else {
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    // console.log("systemLoginValues-98", systemLoginValues);
    return (
      <div className="admin-steps admin-content-area">
        <StickyHeaderPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h3 className="title-medium font-600 mt-5 mb-3 pt-3">
                      Tattoo Consent Form
                    </h3>
                    {/* {systemLoginValues.email} */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6}>
                <p>
                  In consideration of receiving a tattoo from{" "}
                  {this.state.studioName
                    ? this.state.studioName.toUpperCase()
                    : "TATTOO STUDIO"}{" "}
                  including its artists, associates, apprentices, agents, or any
                  employees (hereinafter referred to as the “Tattoo Studio”) I
                  agree to the following:
                </p>
                <Form.Group>
                  <Form.Label>
                    I have have been fully informed of the risks associated with
                    getting a tattoo. I fully understand that these risks, known
                    and unknown, can lead to injury including but not limited
                    to: infection, scarring, difficulties in the detection of
                    melanoma and allergic reactions to tattoo pigment, aftercare
                    products and/or soap. Having been informed of the potential
                    risks associated with getting a tattoo I wish to proceed
                    with the tattoo procedure and application and freely accept
                    and expressly assume any and all risks that may arise from
                    tattooing.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    I WAIVE AND RELEASE to the fullest extent permitted by law
                    any person of the Tattoo Studio from all liability
                    whatsoever, including but not limited to, any and all claims
                    or causes of action that I, my estate, heirs, executors or
                    assigns may have for personal injury or otherwise, including
                    any direct and/or consequential damages, which result or
                    arise from the procedure and application of my tattoo,
                    whether caused by the negligence or fault of either the
                    Tattoo Studio, or otherwise.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label>
                    The Tattoo Studio has given me instructions on the care of
                    my tattoo while it's healing. I understand and will follow
                    them. I acknowledge that it is possible that the tattoo can
                    become infected, particularly if I do not follow the
                    instructions given to me. If any touch-up work to the tattoo
                    is needed due to my own negligence, I agree that the work
                    will be done at my own expense.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    I am not under the influence of alcohol or drugs, and I am
                    voluntarily submitting to be tattooed by the Tattoo Studio
                    without duress or coercion.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label>
                    I am not currently pregnant nor do I have reason to believe
                    that I might be currently pregnant.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    The Tattoo Studio is not responsible for the meaning or
                    spelling of the symbol or text that I have provide to them
                    or chosen from the flash (design) sheets.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label>
                    Variations in color and design may exist between the tattoo
                    art I have selected and the actual tattoo when it is applied
                    to my body. I also understand that over time, the colors and
                    the clarity of my tattoo will fade due to unprotected
                    exposure to the sun and the naturally occurring dispersion
                    of pigment under the skin.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    A tattoo is a permanent change to my appearance and can only
                    be removed by laser or surgical means, which can be
                    disfiguring and/or costly and which in all likelihood will
                    not result in the restoration of my skin to its exact
                    appearance before being tattooed.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label>
                    I release the right to any photographs taken of me and the
                    tattoo and give consent in advance to their reproduction in
                    print or electronic form. (For assurance, if you do not
                    initial this provision, please inform the Tattoo Studio NOT
                    to take any pictures of you and your completed tattoo).
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    I acknowledge that I have been given adequate opportunity to
                    read and understand this document that it was not presented
                    to me at the last minute and grasp that I am signing a legal
                    contract waiving certain rights to recover damages against
                    the Tattoo Studio.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    I agree to IMMEDIATELY notify the artist if I feel
                    lightheaded, dizzy and/or faint before, during or after the
                    procedure. Failure to do so releases the Tattoo Studio and
                    my tattoo artist of all responsibility.
                  </Form.Label>
                  <Form.Control className="w-25" />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <p>
                  If any provision, section, subsection, clause or phrase of
                  this release is found to be unenforceable or invalid, that
                  portion shall be severed from this contract. The remainder of
                  this contract will then be construed as though the
                  unenforceable portion had never been contained in this
                  document.
                </p>

                <p>
                  I hereby declare that I am of legal age (and have provided
                  valid proof of age and identification) and am competent to
                  sign this Agreement.
                </p>

                <p>
                  I HAVE READ THE AGREEMENT, I UNDERSTAND IT, AND I AGREE TO BE
                  BOUND BY IT.
                </p>

                <p>
                  **PLEASE ASK YOUR ARTIST ABOUT THE PRICE OF YOUR TATTOO BEFORE
                  BEGINNING THE PROCEDURE - it is your responsibility to confirm
                  the price of the tattoo, and we assume no responsibility for
                  any misunderstanding in this regard.
                </p>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>:
                  </Form.Label>
                  <Form.Control
                    value={
                      this.state.clientFirstName
                        ? this.state.clientFirstName
                        : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientFirstName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    value={
                      this.state.clientLastName ? this.state.clientLastName : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientLastName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Email:</Form.Label>
                  <Form.Control
                    type="email"
                    value={this.state.clientEmail ? this.state.clientEmail : ""}
                    onChange={(e) =>
                      this.setState({ clientEmail: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Mobile Number:</Form.Label>

                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    onChange={(e) =>
                      this.setState({ clientPhone: e.target.value })
                    }
                    value={
                      this.state.clientPhone
                        ? formatPhoneNumber(this.state.clientPhone)
                        : ""
                    }
                    name="clientPhone"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                  {this.state.errors.clientPhone && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {this.state.errors.clientPhone}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Date:</Form.Label>
                  <Form.Control value={moment().format("MM/DD/YYYY")} />
                </Form.Group>
              </Col>
            </Row>
            {this.state.hasGuardian ? (
              <>
                <Row>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>
                        Guardian Name<span className="text-danger"> *</span>:
                      </Form.Label>
                      <Form.Control
                        value={
                          this.state.guardianName ? this.state.guardianName : ""
                        }
                        onChange={(e) =>
                          this.setState({ guardianName: e.target.value })
                        }
                        isInvalid={!!this.state.errors.guardianName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.guardianName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>Guardian Email:</Form.Label>
                      <Form.Control
                        type="email"
                        value={
                          this.state.guardianEmail
                            ? this.state.guardianEmail
                            : ""
                        }
                        onChange={(e) =>
                          this.setState({ guardianEmail: e.target.value })
                        }
                        isInvalid={!!this.state.errors.guardianEmail}
                      />
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.guardianEmail}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>Guardian Phone:</Form.Label>

                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formControlProps={{
                          fullWidth: true,
                        }}
                        onChange={(e) =>
                          this.setState({ guardianPhone: e.target.value })
                        }
                        value={
                          this.state.guardianPhone
                            ? formatPhoneNumber(this.state.guardianPhone)
                            : ""
                        }
                        name="guardianPhone"
                      >
                        {(inputProps) => <Form.Control {...inputProps} />}
                      </InputMask>
                      {this.state.errors.guardianPhone && (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {this.state.errors.guardianPhone}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>Date:</Form.Label>
                      <Form.Control value={moment().format("MM/DD/YYYY")} />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            ) : (
              ""
            )}
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    {this.state.hasGuardian
                      ? "Guardian Signature"
                      : "Client Signature"}
                  </Form.Label>
                  <div
                    style={{
                      border: "solid 1px lightgray",
                      width: "500px",
                      height: "100px",
                    }}
                  >
                    <SignaturePad
                      canvasProps={{
                        width: 500,
                        height: 100,
                        className: "sigCanvas",
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
        <FooterPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.reducer.transactionData,
  };
};

export default connect(mapStateToProps, {
  getPublicFormTransactionDataAction,
  publicAddDocAction,
  publicUploadDocumentAction,
  loginUserAction,
  logout,
  loginUserPublicFormsAction,
  addContactByPublicFormAction,
})(ConsentPublic);
